export default {
    mixed: {
        required: 'Это обязательное поле',
        notType: ({ type, value, originalValue }) => {
            switch (type) {
                case 'number':
                    return 'Значение должно быть числом';
                case 'object':
                    if (value || originalValue) return;
                    break;
                default:
                    return 'Неверный формат';
            }
        }
    },
    string: {
        email: 'Неверный email',
        min: 'Не меньше ${min} символов', // eslint-disable-line no-template-curly-in-string
        max: 'Не больше ${max} символов', // eslint-disable-line no-template-curly-in-string
        length: (s) => `Длина должны быть ${s.length}`
    },
    number: {
        positive: 'Число должно быть положительным',
        default: 'Значение должно быть числом'
    },
    date: {
        default: 'Неверная дата'
    }
}



// WEBPACK FOOTER //
// ./src/constants/validation.js